import { createDefaultStoreConfig, normalizeStoreConfig } from "./storeDefaults";

const storageKey = (vendorId) => `dealboxx_vendor_store_${vendorId || "guest"}`;

export const loadStoreFromStorage = (vendorId) => {
  try {
    const raw = localStorage.getItem(storageKey(vendorId));
    if (!raw) return createDefaultStoreConfig();
    return normalizeStoreConfig(JSON.parse(raw));
  } catch {
    return createDefaultStoreConfig();
  }
};

export const saveStoreToStorage = (vendorId, config) => {
  const payload = normalizeStoreConfig({
    ...config,
    lastSavedAt: new Date().toISOString(),
  });
  localStorage.setItem(storageKey(vendorId), JSON.stringify(payload));
  return payload;
};
